
import { MVMBaseTabModel } from './mvm-base-tab.model';

export class MVMStandardTabModel extends MVMBaseTabModel {
    showType: string;
    constructor() {
        super();
    }
}
